module.exports = __webpack_public_path__ + "img/CSM.d87db82d.png";